export default {
      id: "twitter-usage",
      viewBox: "0 0 20 16",
      url: "../../assets/" + "sprite.svg#twitter-usage",
      toString: function () {
        return this.url;
      }
    }